@if (isLoading) {
  <div class="xi-loader-container__center">
    <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
  </div>
}

<ng-container *transloco="let t; prefix: 'widgets.options'">
  @if (!isLoading) {
    <div class="xi-modal__container">
      @if (!isBucketView) {
        <h1 class="xi-modal__title kxi-text-center kxi-text-xlarge">
          {{ t(title()) }}
        </h1>
        <ng-container [formGroup]="form">
          <xi-dropdown
            label="{{ t('metric-type') }}"
            formControlName="impactMetric"
            [data]="impactMetricOptions"
          ></xi-dropdown>
        </ng-container>

        @switch (form.controls.impactMetric.value) {
          @case (IMPACT_METRIC.RATING) {
            <div class="rating-field-selector__impact-rating-container">
              <span class="kxi-text-medium kxi-text-600">{{ t('select-rating-field') }}</span>
              <div class="xi-modal__content rating-field-selector__impact-ratings">
                @for (field of ratingFields; track field) {
                  <xi-radio
                    [value]="field.fieldName"
                    [(ngModel)]="selectedField"
                    [label]="field.label"
                    name="impactRating"
                  ></xi-radio>
                }
              </div>
            </div>
          }

          @case (IMPACT_METRIC.BINARY) {
            <div class="rating-field-selector__impact-rating-container">
              <span class="kxi-text-medium kxi-text-600">{{ t('select-numeric-field') }}</span>
              <div class="xi-modal__content rating-field-selector__impact-ratings">
                @for (field of binaryFields; track field) {
                  <xi-radio
                    [value]="field.fieldName"
                    [(ngModel)]="selectedBinaryField"
                    [label]="field.label"
                    name="impactBinary"
                    (onChange)="onBinaryFieldChange($event.detail.target.value)"
                  ></xi-radio>
                }
              </div>
            </div>
          }
          @case (IMPACT_METRIC.BUCKETS) {
            <div class="rating-field-selector__impact-rating-container">
              <span class="kxi-text-medium kxi-text-600">{{ t('select-numeric-field') }}</span>
              <div class="xi-modal__content rating-field-selector__impact-ratings">
                @for (field of bucketFields; track field) {
                  <xi-radio
                    [value]="field.fieldName"
                    [(ngModel)]="selectedBucketField"
                    [label]="field.label"
                    name="impactBucket"
                    (onChange)="onBucketFieldChange($event.detail.target.value)"
                  ></xi-radio>
                }
              </div>
            </div>
          }
        }
      } @else {
        <h1 class="xi-modal__title kxi-text-center kxi-text-xlarge">
          {{ t(bucketTitle) }}
        </h1>

        <ng-container [formGroup]="form">
          <div class="override">
            <xi-checkbox
              formControlName="overrideBucketSettings"
              label="{{ t('override-bucket-settings') }}"
              color="CX"
            ></xi-checkbox>
          </div>

          <div class="bucket-wrapper">
            <app-field-buckets
              [expectedType]="field()?.fieldType"
              [hasRadioSelect]="true"
              [buckets]="field()?.buckets"
              [isReadOnly]="isBucketsReadOnly()"
              [selectedBucketIndex]="selectedBucketIndex"
              (fieldBuckets)="onFieldBuckets($event)"
              (bucketSelectedIndex)="onBucketSelectedIndex($event)"
            ></app-field-buckets>
          </div>
        </ng-container>
      }

      <div class="xi-modal__actions">
        @if (form.controls.impactMetric.value === IMPACT_METRIC.BUCKETS) {
          <xi-default-button
            [text]="data().isBucketView ? data().cancelButtonText : backButtonText"
            fill="text"
            (onClick)="data().isBucketView ? onCancel() : onBack()"
          ></xi-default-button>
          <xi-default-button
            [text]="nextButtonText"
            (onClick)="onNext()"
            [disabled]="isApplyDisabled"
          ></xi-default-button>
        } @else {
          <xi-default-button
            [text]="data().cancelButtonText"
            fill="text"
            (onClick)="onCancel()"
          ></xi-default-button>
          <xi-default-button
            [text]="t('apply')"
            (onClick)="onSave()"
            [disabled]="isSaveDisabled"
          ></xi-default-button>
        }
      </div>
    </div>
  }
</ng-container>
